import React, { type ReactNode } from "react";

import clsx from "clsx";

import { useUser } from "@components/user-context";

interface Props {
  query: string;
  className?: string;
  icon?: ReactNode;
}

export const ViewInCreativeAnalyticsButton = ({
  query,
  className,
  icon,
}: Props) => {
  const { user } = useUser();

  const url = new URL(`${window.location.origin}`);
  url.pathname = user.pathFromRoot("/creative-analytics");
  url.searchParams.set("searchText", query);

  return (
    <a
      className={clsx(
        className ??
          "button secondary-button sm inline-block no-underline font-bold",
        "flex items-center gap-2",
      )}
      href={url.toString()}
      target="_blank"
      rel="noreferrer"
    >
      {icon}
      VIEW IN CREATIVE ANALYTICS
    </a>
  );
};
